export default __webpack_public_path__ + "static/media/verified-icon.fb69fb8f.svg";